import { GeneralDetailsSectionState, GeneralSecurityTelemetrySectionState } from './general.types';
import { DataLoadedStatus, SectionStatusType } from '../../types';

export const defaultGeneralDetailsState: GeneralDetailsSectionState = {
  isValid: true,
  status: { type: SectionStatusType.NONE },
  additionalInfo: {
    policyValidityLoaded: DataLoadedStatus.NOT_LOADED,
  },
};

export const defaultGeneralSecurityTelemetryState: GeneralSecurityTelemetrySectionState = {
  isValid: true,
  status: { type: SectionStatusType.NONE },
  additionalInfo: {
    serverUrlValidityLoaded: DataLoadedStatus.NOT_LOADED,
  },
};
